import React, { useContext, useState } from 'react'

import { useQuery } from '@apollo/client'
import { format } from 'date-fns'

import { DateRange, initDateRange } from 'tools/DateRange'
import {
  ActionTable as Atable,
  ActionTableBody as Atbody,
  ActionTableCell as Atd,
  ActionTableHeadCell as Ath,
  ActionTableHeading as Athead,
  ActionTableRow as Atr
} from 'tools/Table/Action'
import { StretchEllipsisText } from 'tools/Uniform'
import { MaxViewPage } from 'tools/Uniform'
import { strcmp, uncamelCase, unsnakeCase } from 'utils/string'

import { ORG_LOGS } from 'hub/Org/graphql'

import OrgContext from '../reducer'

function OrgActivitys() {
  const [org] = useContext(OrgContext)
  const [logs, setLogs] = useState([])
  const [{ start, strStart, end, strEnd }, setDateRange] = useState(initDateRange)

  useQuery(ORG_LOGS, {
    variables: {
      id: org.id,
      start,
      end
    },
    skip: !org?.id,
    onCompleted({ orgs }) {
      const activitys = orgs.success && orgs.results[0].activitys[0].results
      if (Array.isArray(activitys)) {
        const logs = activitys
          .toSorted((a, b) => strcmp(b.insertedAt, a.insertedAt))
          .map((log) => {
            const resourceType = uncamelCase(log.resourceType.split('.').at(-1))
            const insertedAt = format(
              new Date(log.insertedAt),
              'yyyy-MM-dd k:mm:ss'
            )
            const typeName = unsnakeCase(log.type.name)
            const actor = log?.actor?.name
            return {
              ...log,
              actor,
              insertedAt,
              resourceType,
              typeName,
              resourceId: log.resourceId
            }
          })

        setLogs(logs)
      }
    }
  })

  return (
    <MaxViewPage>
      <h1 className="mt4 mb3">Activity Logs</h1>
      <div className="pt2 pb3">
        <DateRange
          start={strStart}
          end={strEnd}
          onStartChange={setDateRange}
          onEndChange={setDateRange}
        />
      </div>
      <Atable className="w-100 list">
        <Athead>
          <Ath>Timestamp</Ath>
          <Ath>Resource</Ath>
          <Ath>Action</Ath>
          <Ath>Actor</Ath>
        </Athead>
        <Atbody>
          {logs.map(
            ({ id, actor, resourceType, resourceId, typeName, insertedAt }) => (
              <Atr key={id}>
                <Atd>{insertedAt}</Atd>
                <Atd className="ttc pa2">
                  <div className="flex flex-column">
                    <StretchEllipsisText
                      className="f1"
                      text={resourceId ?? '—'}
                      clipboard={false}
                    />
                    <span className="f2">{resourceType}</span>
                  </div>
                </Atd>
                <Atd className="ttc pa2">{typeName}</Atd>
                <Atd>{actor ?? '—'}</Atd>
              </Atr>
            )
          )}
        </Atbody>
      </Atable>
    </MaxViewPage>
  )
}

export default OrgActivitys
